"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.EventPreventionWrapper = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/extends"));
var _react = _interopRequireDefault(require("react"));
const EventPreventionWrapper = _ref => {
  let {
    children,
    ...props
  } = _ref;
  const preventEvents = event => {
    if (event.eventPhase === Event.BUBBLING_PHASE) {
      event.stopPropagation();
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    onClick: preventEvents
  }, props), children);
};
exports.EventPreventionWrapper = EventPreventionWrapper;